module.exports = __webpack_public_path__ + "media/assets/images/close-c86ae7a3b47146b91d01c46b37f7edc1.png";